import { equipmentDefinition } from "@frontier/content/arsenal";
import type { ArsenalIntent } from "./arsenal-operations";

export function ArsenalPending({
  pending,
  busy,
  onRetry,
}: {
  pending: readonly ArsenalIntent[];
  busy: boolean;
  onRetry: (intent: ArsenalIntent) => Promise<void>;
}) {
  if (!pending.length) return null;
  return (
    <aside
      className="arsenal-pending"
      aria-label="Неподтверждённые операции арсенала"
    >
      {pending.map((intent) => (
        <div key={intent.requestId}>
          <span>
            {equipmentDefinition(intent.key).name} ·{" "}
            {intent.operation === "craft"
              ? "Изготовление I"
              : intent.operation === "upgrade"
                ? `Улучшение ${"I".repeat(intent.fromTier + 1)} → ${"I".repeat(intent.fromTier + 2)}`
                : `Разбор ${"I".repeat(intent.tier + 1)}`}
          </span>
          <button disabled={busy} onClick={() => void onRetry(intent)}>
            Проверить операцию
          </button>
        </div>
      ))}
    </aside>
  );
}
